import { render } from "./CourseSelect.vue?vue&type=template&id=32bfcbf0&scoped=true&ts=true"
import script from "./CourseSelect.vue?vue&type=script&lang=ts"
export * from "./CourseSelect.vue?vue&type=script&lang=ts"

import "./CourseSelect.vue?vue&type=style&index=0&id=32bfcbf0&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bfcbf0"]])

export default __exports__